// eslint-disable-next-line no-unused-vars
import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles// ..
import mum from '@/assets/img/mum.JPG'
const Welcome = () => {
  useEffect(()=>{
    AOS.init({duration: 4000});
  },[])
  return (
    <div>
      <section>
  <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8 lg:py-16">
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
      <div className="relative h-64 overflow-hidden rounded-lg sm:h-80 lg:order-last lg:h-full" data-aos = "fade-left">
        <img
          alt=""
          src={mum}
          className="absolute inset-0 h-full w-full object-cover "   
        />
        
      </div>

      <div className="lg:py-24"><div data-aos="fade-left"></div>
        <h2 className="text-3xl font-bold sm:text-4xl">Proprietress Welcome Address</h2>
        
        <p className="mt-4 text-gray-600" data-aos = "fade-right" >
        Welcome to Abundance Private Schools, where everyone is treated equally, encouraged, and respected in a happy, caring, and fun environment. We hope you find all the information you're looking for and that our website provides you with an insight into the vibrant life of our very exciting school. 
<p>
APS is a multilingual institution; a citadel of great discovery. Our aim is to produce global citizens whose journey through our school develops and hones their talents, establishes a strong sense of self-esteem, and fosters a life-long love for learning. We are dedicated to ensuring that our students enjoy their educational journey while achieving academic excellence.
</p> 
<p>
At Abundance Private Schools, we believe in the holistic development of each child, and we strive to create an environment where every student feels valued and inspired to reach their full potential. Thank you for considering APS, and we look forward to being a part of your child's educational journey. 
</p> 

        </p>
   <a href="https://wa.me/22997221918" target="_blank" rel="noopener noreferrer" className='absolute py-5 '>
   <button
  className="group flex items-center justify-start w-11 h-11 bg-[#36c142] rounded-full cursor-pointer relative overflow-hidden transition-all duration-200 shadow-lg hover:w-32 hover:rounded-lg active:translate-x-1 active:translate-y-1"
>
  <div
    className="flex items-center justify-center w-full transition-all duration-300 group-hover:justify-start group-hover:px-3"
  >
   
   <svg className='w-5 h-5'  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="#ffffff"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-brand-whatsapp"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" /><path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" /></svg>

  </div>
  <div
    className="absolute right-5 transform translate-x-full opacity-0 text-white text-lg font-semibold transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100"
  >
   Let's Talk
  </div>
</button>
    </a>     

      </div>
    </div>
  </div>
</section>
    </div>
  )
}

export default Welcome
